(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alamo-mix-presets"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alamo-mix-presets')) {
    customElements.define('alamo-mix-presets', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.linkToBuilder === 'true') return;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.ready = () => window.requestAnimationFrame(() => this.enableAvailableMixes());
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-select-mix]');
          if (button && this.contains(button) && !button.disabled) this.selectMix(button);
        }, { signal });
        document.addEventListener('click', event => {
          const builder = this.getBuilder();
          if (event.isTrusted && builder?.contains(event.target) && event.target.closest('.qty-btn, .bundle-tab, .bundle-image-add')) this.clearSelection();
        }, { signal });
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.ready, { once: true, signal });
        else this.ready();
        document.addEventListener('shopify:section:load', this.ready, { signal });
        document.addEventListener('alamo:bundle-ready', this.ready, { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      getBuilder() {
        return Array.from(document.querySelectorAll('.bundle-builder-wrapper')).find(builder => builder.dataset.sectionId === this.dataset.builderSection || builder.dataset.sectionId.endsWith('__' + this.dataset.builderSection));
      }

      getTwoOunceList(builder) {
        return Array.from(builder.querySelectorAll('.bundle-product-list')).find(list => list.dataset.presentation === '2oz');
      }

      getMixItems(card, list) {
        const availableItems = Array.from(list.querySelectorAll('.bundle-item'));
        return Array.from(card.querySelectorAll('[data-mix-flavor]')).map(flavor => ({
          item: availableItems.find(item => item.dataset.variantId === flavor.dataset.variantId),
          quantity: Number(flavor.dataset.quantity)
        }));
      }

      enableAvailableMixes() {
        const builder = this.getBuilder();
        const list = builder && this.getTwoOunceList(builder);
        if (!list || builder.dataset.alamoReady !== 'true' || !builder.querySelector('#bundle-add-to-cart') || Number(builder.dataset.minQty) !== 7) return;
        this.querySelectorAll('[data-mix-card]').forEach(card => {
          const button = card.querySelector('[data-select-mix]');
          const items = this.getMixItems(card, list);
          if (button) button.disabled = !items.length || items.some(entry => !entry.item || !entry.item.querySelector('.qty-btn.plus')) || items.reduce((total, entry) => total + entry.quantity, 0) !== 7;
        });
        if (!this.autoSelectionDone && builder.dataset.alamoReady === 'true') {
          const requestedMix = new URLSearchParams(window.location.search).get('mix');
          const card = Array.from(this.querySelectorAll('[data-mix-card]')).find(item => item.dataset.mixKey === requestedMix);
          const button = card?.querySelector('[data-select-mix]');
          if (button && !button.disabled) {
            this.autoSelectionDone = true;
            this.selectMix(button);
          }
        }
      }

      clearSelection() {
        this.querySelectorAll('[data-mix-card]').forEach(card => {
          card.classList.remove('is-selected');
          card.querySelector('[data-select-mix]')?.setAttribute('aria-pressed', 'false');
        });
        this.querySelector('[data-mix-status]').textContent = '';
      }

      async selectMix(button) {
        const card = button.closest('[data-mix-card]');
        const builder = this.getBuilder();
        const list = builder && this.getTwoOunceList(builder);
        if (!list) return;
        const entries = this.getMixItems(card, list);
        const tab = Array.from(builder.querySelectorAll('.bundle-tab')).find(candidate => candidate.dataset.tab === list.id);
        if (!tab || entries.some(entry => !entry.item)) {
          this.querySelector('[data-mix-status]').textContent = this.dataset.unavailableMessage;
          return;
        }
        if (builder.dataset.instantCart === 'true') {
          this.querySelectorAll('[data-select-mix]').forEach(control => { control.disabled = true; });
          const applied = await builder.alamoApplyMix(entries);
          this.enableAvailableMixes();
          if (!applied) return;
          tab.click();
        } else {
        tab.click();
        if (Array.from(builder.querySelectorAll('.qty-input')).some(input => Number(input.value) !== 0)) {
          this.querySelector('[data-mix-status]').textContent = this.dataset.unavailableMessage;
          return;
        }
        entries.forEach(entry => {
          for (let count = 0; count < entry.quantity; count += 1) entry.item.querySelector('.qty-btn.plus').click();
        });
        if (entries.some(entry => Number(entry.item.querySelector('.qty-input').value) !== entry.quantity) || builder.querySelector('#bundle-add-to-cart').disabled) {
          this.querySelector('[data-mix-status]').textContent = this.dataset.unavailableMessage;
          return;
        }
        }
        this.clearSelection();
        card.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        if (builder.dataset.instantCart === 'true') {
          const url = new URL(window.location.href);
          if (url.searchParams.get('mix') === card.dataset.mixKey) {
            url.searchParams.delete('mix');
            window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
          }
        }
        this.querySelector('[data-mix-status]').textContent = this.dataset.selectedMessage.replace('__MIX__', card.dataset.mixTitle);
        const heading = builder.querySelector('.bundle-heading');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
        }
        builder.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-now"] && !Shopify.designMode) return;
  try {
    
(() => {
  function updateHangingSigns() {
    const show = Boolean(window.Shopify?.designMode) ||
      window.scrollY >= window.innerHeight;

    document.querySelectorAll('[id^="hanging-sign-"]').forEach(sign => {
      sign.classList.toggle('visible', show);
    });
  }

  window.addEventListener('scroll', updateHangingSigns, { passive: true });
  window.addEventListener('resize', updateHangingSigns);
  document.addEventListener('shopify:section:load', updateHangingSigns);
  document.addEventListener('shopify:section:select', updateHangingSigns);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHangingSigns, { once: true });
  } else {
    updateHangingSigns();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
